import {saveStoryVersion} from './storyVersions.js';
// A reviewer can only name published Story passages or their own transcript-backed selects.
// IDs are references, never client-written quotes or timecodes.
export const draftRef=item=>item.type+':'+item.id;
export function draftAvailable(snapshot,ownFeedback=[]){
 const base=(snapshot?.blocks||[]).filter(b=>b.id).map((b,i)=>({
  type:'block',id:b.id,text:b.text||'',sourceId:b.sourceId,
  start:b.start,end:b.end,sourceTitle:(snapshot.sources||[]).find(s=>s.id===b.sourceId)?.title||'Interview',
  subtitle:'Published Story · passage '+(i+1)}));
 const selections=ownFeedback.filter(n=>n.kind==='select'&&n.id).map(n=>({
  type:'select',id:n.id,text:n.quote||'',sourceId:n.source_id,
  start:n.words?.[0]?.start,end:n.words?.at(-1)?.end,
  sourceTitle:n.source_title||'Interview',subtitle:'Your suggested select'}));
 return [...base,...selections];
}
export function validateDraftSequence(sequence,available){
 if(!Array.isArray(sequence)||sequence.length<1||sequence.length>60)throw new Error('Choose 1–60 passages.');
 const byKey=new Map(available.map(x=>[draftRef(x),x]));
 const seen=new Set();
 return sequence.map(item=>{
  const key=draftRef(item);
  if(!byKey.has(key)||seen.has(key))throw new Error('A passage is missing or included twice.');
  seen.add(key);return byKey.get(key);
 });
}
export function previewDraftBlocks(sequence,available){
 return validateDraftSequence(sequence,available).map(item=>({
  id:item.type==='block'?item.id:'review-select:'+item.id,
  sourceId:item.sourceId,start:item.start,end:item.end,text:item.text||'',
  ...(item.type==='select'?{reviewFeedbackId:item.id}:{})
 }));
}
export function draftProposedOrder(paper,sequence,available){
 // Only reorder existing editor clips; never replace or delete media.
 const selected=validateDraftSequence(sequence,available);
 const byId=new Map((paper.blocks||[]).map(b=>[b.id,b]));
 const byFeedback=new Map((paper.blocks||[]).filter(b=>b.reviewFeedbackId).map(b=>[b.reviewFeedbackId,b]));
 const used=new Set();
 const ordered=[];
 for(const entry of selected){
  const passage=entry.type==='block'?byId.get(entry.id):byFeedback.get(entry.id);
  if(passage&&!used.has(passage.id)){ordered.push(passage);used.add(passage.id);}
 }
 for(const passage of paper.blocks||[])if(!used.has(passage.id))ordered.push(passage);
 return ordered;
}
export function applyDraftOrdering(paper,sequence,available,title){
 const ordered=draftProposedOrder(paper,sequence,available);
 if(ordered.every((b,i)=>b.id===paper.blocks[i].id))return paper;
 const saved=saveStoryVersion(paper,{title:'Before client draft · '+String(title||'Reviewer').slice(0,45),
  note:'Automatic safety snapshot before importing a client-proposed passage order.'});
 return {...saved,blocks:ordered};
}
